import PropTypes from 'prop-types'
import theme from '../../constants/theme'

const NotFoundIcon = ({
  color = theme.talentinoSpecialBlue,
  style,
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: '45%', height: '45%', color, ...style }}
    {...props}
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </svg>
)

NotFoundIcon.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
}

export default NotFoundIcon
